// removed by extract-text-webpack-plugin
module.exports = {"content1":"Table__content1__39HVg","content2":"Table__content2__1GOQA","Black":"Table__Black__vEXbG","White":"Table__White__hmfX_","switchfield":"Table__switchfield__1QpSs","filterDiv":"Table__filterDiv__WVRdo","filterSpan":"Table__filterSpan__7PPH_","br_for_mobile":"Table__br_for_mobile__2KMX1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Table/Table.css
// module id = 104
// module chunks = 17